import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { PromiseStatuses } from "../../../../utils"
import { ComparisonResponseDTO, filtersDTO, saveStatusParticelleStruttureDTO } from "./dataService/dto"
import { NewNotComparisonService } from "./dataService/service"

interface NotComparisonState {
    filtersComparison: filtersDTO
    GetComparisonResponse?: ComparisonResponseDTO
    GetComparisonResponsestatus: PromiseStatuses
    currentNotificationStatusId: string
    saveUpdateStatusParticelleRequest: saveStatusParticelleStruttureDTO
    saveUpdateStatusStruttureRequest: saveStatusParticelleStruttureDTO
    NotUpdateStatusParticelleStatus: PromiseStatuses
    NotUpdateStatusStruttureStatus: PromiseStatuses
}

const initialState: NotComparisonState = {
    filtersComparison: {
        page: 0,
        itemsPerPage: 0,
        currentNotificationId: '0',
        previousNotificationId: '0',
    },
    saveUpdateStatusParticelleRequest: {
        addedInfo: '',
        removedInfo: '',
        variationCausesType: '',
        officerId: '',
    },
    saveUpdateStatusStruttureRequest: {
        addedInfo: '',
        removedInfo: '',
        variationCausesType: '',
        officerId: '',
    },
    currentNotificationStatusId: '',
    GetComparisonResponsestatus: 'idle',
    NotUpdateStatusParticelleStatus: 'idle',
    NotUpdateStatusStruttureStatus: 'idle'
}

export const GetComparison = createAsyncThunk(
    'Not/GetComparison',
    async (filters: filtersDTO, thunkApi): Promise<ComparisonResponseDTO> => {
        const NotComparisonService = NewNotComparisonService()
        return NotComparisonService.GetNotComparison(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const NotComparisonUpdateStatusParticelle = createAsyncThunk(
    'Not/NotComparisonUpdateStatusParticelle',
    async (request: { body: saveStatusParticelleStruttureDTO, id: string }, thunkApi): Promise<void> => {
        const NotComparisonService = NewNotComparisonService()
        return NotComparisonService.UpdateStatusParticelle(request.body, request.id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const NotComparisonUpdateStatusStrutture = createAsyncThunk(
    'Not/NotComparisonUpdateStatusStrutture',
    async (request: { body: saveStatusParticelleStruttureDTO, id: string }, thunkApi): Promise<void> => {
        const NotComparisonService = NewNotComparisonService()
        return NotComparisonService.UpdateStatusStrutture(request.body, request.id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const NotComparisonSlice = createSlice({
    name: 'notComparison/slice',
    initialState,
    reducers: {
        resetFilters: (state) => {
            state.filtersComparison = {
                page: 0,
                itemsPerPage: 0,
                currentNotificationId: '0',
                previousNotificationId: '0'
            }
        },
        resetGetCompareStatus: (state) => {
            state.GetComparisonResponsestatus = 'idle'
        },
        setCurrentNotId: (state, action) => {
            state.filtersComparison.currentNotificationId = action.payload
        },
        setCurrentNotStatusId: (state, action) => {
            state.currentNotificationStatusId = action.payload
        },
        setNotStatusTypeParticelleStrutture: (state, action) => {
            state.saveUpdateStatusParticelleRequest.variationCausesType = action.payload
        },
        setNotStatusTypeStruttureStrutture: (state, action) => {
            state.saveUpdateStatusStruttureRequest.variationCausesType = action.payload
        },
        setNotStatusOfficerId: (state, action) => {
            state.saveUpdateStatusParticelleRequest.officerId = action.payload
        },
        setSaveStatusParticelleAlienate: (state, action) => {
            state.saveUpdateStatusParticelleRequest.removedInfo = action.payload
        },
        setSaveStatusParticelleInserite: (state, action) => {
            state.saveUpdateStatusParticelleRequest.addedInfo = action.payload
        },
        setSaveStatusStruttureAlienate: (state, action) => {
            state.saveUpdateStatusStruttureRequest.removedInfo = action.payload
        },
        setSaveStatusStruttureInserite: (state, action) => {
            state.saveUpdateStatusStruttureRequest.addedInfo = action.payload
        },
        resetSaveStatusParticelleAlienate: (state, action) => {
            state.saveUpdateStatusParticelleRequest = {
                addedInfo: '',
                removedInfo: '',
                variationCausesType: '',
                officerId: '',
            }
        },
        setPrevNotId: (state, action) => {
            state.filtersComparison.previousNotificationId = action.payload
        },

    },
    extraReducers(builder) {
        builder
            .addCase(GetComparison.pending, (state) => {
                state.GetComparisonResponsestatus = 'loading'
            })
            .addCase(GetComparison.fulfilled, (state, action) => {
                state.GetComparisonResponsestatus = 'successfully'
                state.GetComparisonResponse = action.payload
            })
            .addCase(GetComparison.rejected, (state, action) => {
                state.GetComparisonResponsestatus = 'failed'
            })

            .addCase(NotComparisonUpdateStatusParticelle.pending, (state) => {
                state.NotUpdateStatusParticelleStatus = 'loading'
            })
            .addCase(NotComparisonUpdateStatusParticelle.fulfilled, (state, action) => {
                state.NotUpdateStatusParticelleStatus = 'successfully'
            })
            .addCase(NotComparisonUpdateStatusParticelle.rejected, (state, action) => {
                state.NotUpdateStatusParticelleStatus = 'failed'
            })

            .addCase(NotComparisonUpdateStatusStrutture.pending, (state) => {
                state.NotUpdateStatusStruttureStatus = 'loading'
            })
            .addCase(NotComparisonUpdateStatusStrutture.fulfilled, (state, action) => {
                state.NotUpdateStatusStruttureStatus = 'successfully'
            })
            .addCase(NotComparisonUpdateStatusStrutture.rejected, (state, action) => {
                state.NotUpdateStatusStruttureStatus = 'failed'
            })
    }
})

export const {
    resetFilters,
    setCurrentNotId,
    resetGetCompareStatus,
    setSaveStatusParticelleInserite,
    setSaveStatusParticelleAlienate,
    resetSaveStatusParticelleAlienate,
    setNotStatusTypeParticelleStrutture,
    setSaveStatusStruttureInserite,
    setSaveStatusStruttureAlienate,
    setCurrentNotStatusId,
    setNotStatusOfficerId,
    setPrevNotId
} = NotComparisonSlice.actions

export default NotComparisonSlice.reducer